import { createContext, useContext } from 'react';

export interface CheckboxGroupContextValue {
  value: string[];
  onChange: (value: string[]) => void;
  disabled: boolean;
}

/** Provided by [[CheckboxGroup]]; consumed by [[Checkbox]] so a `value`-keyed
 *  box reflects and edits the group selection. Null when a Checkbox is used
 *  on its own. */
export const CheckboxGroupContext =
  createContext<CheckboxGroupContextValue | null>(null);

export const useCheckboxGroupContext = () => useContext(CheckboxGroupContext);
